import { render, staticRenderFns } from "./safety-standard.vue?vue&type=template&id=69fa02d2"
import script from "./safety-standard.vue?vue&type=script&lang=js"
export * from "./safety-standard.vue?vue&type=script&lang=js"
import style0 from "./safety-standard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports